import { Link, useHistory } from 'react-router-dom';
import { useDispatch } from 'react-redux'
import { useState, setState } from 'react';

// MUI IMPORTS
import Grid from '@mui/material/Grid';
import Card from '@mui/material/Card';
import CardActions from '@mui/material/CardActions';
import CardContent from '@mui/material/CardContent';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import RadioGroup from '@mui/material/RadioGroup';
import Radio from '@mui/material/Radio';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormControl from '@mui/material/FormControl';
import FormLabel from '@mui/material/FormLabel';
import LinearProgress, { LinearProgressProps } from '@mui/material/LinearProgress';


function Supported() {

    const [rating, setRating] = useState(0);
    const dispatch = useDispatch();
    const history = useHistory();

    const handleSupport = (e) => {
        e.preventDefault();
        console.log(rating);
        const action = {
            type: 'SUPPORT_INPUT',
            payload: rating
        }
        dispatch(action);
        history.push('/four');
    };

    return (
        <Grid container spacing={0} direction="column" alignItems="center" justify="center" style={{ minHeight: '100vh' }}>
            <Grid item xs={3}>
                <Card sx={{ maxWidth: 850 }} className="feedbackCard">
                    <CardContent>
                        <Typography variant='h5'>How Supported do you Feel?</Typography>
                    </CardContent>
                    <CardContent>
                        <form onSubmit={handleSupport}>
                            <RadioGroup name="supportedradio">
                                <FormControlLabel control={<Radio required />} label="1 - My needs are not being met" value="1" onChange={(event) => setRating(event.target.value)}></FormControlLabel>
                                <FormControlLabel control={<Radio />} label="2 - Could be Better ..." value="2" onChange={(event) => setRating(event.target.value)}></FormControlLabel>
                                <FormControlLabel control={<Radio />} label="3 -  Average" value="3" onChange={(event) => setRating(event.target.value)}></FormControlLabel>
                                <FormControlLabel control={<Radio />} label="4 - I feel somewhat supported" value="4" onChange={(event) => setRating(event.target.value)}></FormControlLabel>
                                <FormControlLabel control={<Radio />} label="5 - I feel VERY supported" value="5" onChange={(event) => setRating(event.target.value)}></FormControlLabel>
                            </RadioGroup>
                            <Button onClick={() => history.push('/two')}>
                                PREV
                            </Button>
                            <Button type="submit" variant='outlined'>NEXT</Button>
                        </form>
                    </CardContent>
                    <CardContent>
                        <LinearProgress variant="determinate" value={40} />
                    </CardContent>
                </Card >
            </Grid>
        </Grid>
    )
}

export default Supported;